module.exports = __webpack_public_path__ + "static/016.thumb-467ed1bcc433b5a7f6a8283225ccd9bb.jpg";